import * as React from 'react';
import { FormattedMessage } from 'react-intl';

interface DriverInfoProps {
  order: models.Order;
}

class DriverInfo extends React.Component<DriverInfoProps, {}> {

  render() {

    let styles = {
      title: {
        fontSize: '24px',
        padding: '14px 0',
        fontWeight: 'bold' as 'bold'
      },
      car: {
        padding: '0 1em 1em 1em',
        fontSize: '18px',
        position: 'relative' as 'relative',
        boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.25)',
        zIndex: 1000        
      },
      buttons: {
        lineHeight: '32px',
        textAlign: 'center',
        paddingTop: '8px'
      },
      category: {
        display: 'inline-block',
        color: 'white',
        width: '48%',
        float: 'left'
      },
      number: {
        display: 'inline-block',
        border: '1px solid black',
        width: '48%',
        float: 'right'
      },
      phone: {
        textTransform: 'uppercase',
        background: '#28B478'
      },
      link: {
        textDecoration: 'none',
        color: '#FAFAFA',
        display: 'flex'
      }
    };

    const autoStr = (this.props.order.driver.car.brand || '') + ' ' +
      (this.props.order.driver.car.model || '') + ' ' +
      (this.props.order.driver.car.color || '') + ' ' +
      (this.props.order.driver.car.year || '');

    let statusId: string;

    switch (this.props.order.status) {
      case 'ACCEPTED':
        statusId = 'Status.Accepted';
        break;
      case 'ARRIVED':
        statusId = 'Status.Arrived';
        break;
      case 'IN_PROGRESS':
        statusId = 'Status.Processing';
        break;
      default:
        statusId = 'Status.Error';
    }

    let carCategory = '';
    if (this.props.order.driver && this.props.order.driver.car && this.props.order.driver.car.category) {
      carCategory = 'cat-' + this.props.order.driver.car.category.toLowerCase();
    }

    return (
      <div className="car-block" style={styles.car}>
        <div style={styles.title}>
          <FormattedMessage id={statusId} />
        </div>
        <div className="car-info">
          <FormattedMessage id="Order.Driver" />
          <span>{this.props.order.driver.name}</span>
        </div>
        <div className="car-info">
          <FormattedMessage id="Order.Phone" />
          <span>{this.formatPhone(this.props.order.driver.phone)}</span>
        </div>
        <div className="car-info" style={{ paddingTop: '0.5em' }}>
          <FormattedMessage id="Order.Auto" />
          <span>{autoStr}</span>
          <div style={styles.buttons}>
            <div className={'car-category ' + carCategory} style={styles.category}>
              <FormattedMessage id={this.props.order.driver.car.category} />
            </div>
            <div style={styles.number}>{this.formatCarNumber(this.props.order.driver.car.number)}</div>
          </div>
          <div style={{clear: 'both'}}/>
        </div>
        <div id="phoneBtn" style={styles.phone}>
          <a href={'tel:' + this.props.order.driver.phone} style={styles.link}>
            <img src="/img/phone.svg" />
            <FormattedMessage id="Phone.Call"/>
          </a>
        </div>
      </div>
    );
  }

  private formatPhone(phone: string): string {

    let countryCode = phone.slice(-12, 3) || '38';
    return '+' + countryCode + ' (' + phone.slice(-10, -7) + ') ' +
      phone.slice(-7, -5) + '-' + phone.slice(-5, -3) + '-' + phone.slice(-3);
  }

  private formatCarNumber(num: string): string {
    let arr = num && num.replace(/[-\s]/g, '').match(/\d+|\D+/g);
    return arr ? arr.join(' ') : '';
  }
}

export default DriverInfo;


// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/DriverInfo.tsx